module.exports = __webpack_public_path__ + "static/img/12bg_8.6ff1b59.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_8.png
// module id = 647
// module chunks = 1